import React, { useContext, useState, useEffect } from 'react'
import moment from 'moment'

import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'
import FullScreenPopup from '../../product/components/organisms/FullScreenPopup'
import ProductContext from '../../product/context/product/productContext'
import CustomCommonContext from '../../custom/context/common/commonContext'
import ProductCommonContext from '../../product/context/common/commonContext'
import UserContext from '../../product/context/user/userContext'

import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../product/common/components'

import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@mui/material'
import Loaders from '../../product/components/molecules/Loaders'
const SingleListing = (props) => {
    const { projectAction, single_project, getSingleProject } =
        useContext(ProductContext)
    const [isLoading, setIsLoading] = useState(false)

    const [reload, setReload] = useState(false)

    // const { allCategory, allCondition } = useContext(CustomCommonContext)

    const data = props.data
    const toggleFullScreenPopup = props.function
    const validationArray = Yup.object({
        title: Yup.string().required('Required!'),
        date_added: Yup.date('Please enter valid Date!')
            .nullable()
            .typeError('Required!')
            .required('Required!'),
        date_closed: Yup.date('Please enter valid Date!')
            .transform((__, value) =>
                value && typeof value === 'string'
                    ? new Date(
                          moment(new Date(value.replace(/-/g, '/'))).subtract(
                              1,
                              'minutes'
                          )
                      )
                    : new Date(moment(value).subtract(1, 'minutes'))
            )
            .min(Yup.ref('date_added'), 'Should be greater than start Time')
            .nullable()
            .typeError('Required!')
            .required('Required!'),
        qty: Yup.number()
            .required('Required!')
            .positive('Should be greater than 1'),
        desc_proc: Yup.string().required('Required!'),
        // auction: Yup.boolean(),
        auction: Yup.boolean().when('buynow', {
            is: false,
            then: Yup.boolean().oneOf([true], 'Enable Auction or Buy Now'),
        }),
        sprice: Yup.number().when('auction', {
            is: true,
            then: Yup.number()
                .required('Required!')
                .positive('Should be greater than 1'),
        }),
        rprice: Yup.number().when('auction', {
            is: true,
            then: Yup.number()
                .positive('Should be greater than 1')
                .min(
                    Yup.ref('sprice'),
                    'Should be equal or greater than the starting price'
                )
                .required('Required!'),
        }),
        buynow: Yup.boolean(),
        bprice: Yup.number().when('buynow', {
            is: true,
            then: Yup.number()
                .required('Required!')
                .positive('Should be greater than 1')
                .when('auction', {
                    is: true,
                    then: Yup.number().moreThan(
                        Yup.ref('rprice'),
                        'Should be greater than the reserve price'
                    ),
                }),
        }),
        uploadimages: Yup.array().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            title: '',
            date_added: dateTimeFormatFunction(new Date()),
            date_closed: dateTimeFormatFunction(new Date()),
            qty: 0,
            desc_proc: '',
            auction: false,
            sprice: 0,
            rprice: 0,
            buynow: false,
            bprice: 0,
            uploadimages: [],
            market_status: 'open',
            auctiontype: 'live',
            group_carts: 1,
            local_pickup_check: 1,
            shipping_check: 0,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            const value = values
            value.date_added = moment(
                value.date_added,
                'MM-DD-YYYY h:mm a'
            ).format()
            value.date_closed = moment(
                value.date_closed,
                'MM-DD-YYYY h:mm a'
            ).format()
            projectAction(value)
        },
    })

    const formSubmit = (data) => {
        formik.values.market_status = data
        formik.submitForm().then(setIsLoading(false)).catch(setIsLoading(false))
    }

    useEffect(() => {
        if (data.status === 'edit') {
            setIsLoading(true)
            formik.values.id = data.id
            getSingleProject(formik.values)
        } else {
            setIsLoading(false)
            formik.values.id = 0
            resetFrom()
        }
    }, [data])
    useEffect(() => {
        if (data.status == 'new') {
            setIsLoading(false)
        }
    }, [data.status])
    useEffect(() => {
        setIsLoading(false)
    }, [])
    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        if (single_project.record && data.status === 'edit') {
            const project = single_project.record
            formik.values.title = project.title
            formik.values.date_added = dateTimeFormatFunction(
                project.date_added
            )
            formik.values.date_closed = dateTimeFormatFunction(
                project.date_closed
            )
            formik.values.qty = project.qty
            formik.values.desc_proc = project.desc_proc ? project.desc_proc : ''
            formik.values.auction = project.auction
            formik.values.sprice = project.sprice
            formik.values.rprice = project.rprice
            formik.values.buynow = project.buynow === 1 ? true : false
            formik.values.bprice = project.bprice
            formik.values.uploadimages = project.uploadimages
                ? project.uploadimages.toString().split(',')
                : []
            formik.values.market_status = project.market_status
            setReload(!reload)
            setIsLoading(false)
        }
    }, [single_project])

    useEffect(() => {
        if (formik.values.date_closed && formik.values.date_added) {
            let dateClosed = moment(
                formik.values.date_closed,
                'MM-DD-YYYY h:mm a'
            ).format()
            let dateAdded = moment(
                formik.values.date_added,
                'MM-DD-YYYY h:mm a'
            ).format()
            if (dateClosed <= dateAdded) {
                formik.values.date_closed = null
                setReload(!reload)
            }
        }
    }, [formik.values.date_added, formik.values.date_closed])

    const resetFrom = () => {
        console.log('reset form')
        formik.values.id = 0
        formik.values.title = ''
        formik.values.date_added = dateTimeFormatFunction(new Date())
        formik.values.date_closed = dateTimeFormatFunction(new Date())
        formik.values.qty = 0
        formik.values.desc_proc = ''
        formik.values.auction = false
        formik.values.sprice = 0
        formik.values.rprice = 0
        formik.values.buynow = false
        formik.values.bprice = 0
        formik.values.uploadimages = []
        formik.values.market_status = 'open'
        formik.handleReset()
        setReload(!reload)
    }

    const productListing = [
        {
            label: 'Listing Title *',
            type: 'text',
            placeholder: 'Enter your Listing Title',
            class: 'col-sm-6 col-12',
            name: 'title',
            formik: formik,
        },
        {
            label: 'Start date *',
            placeholder: 'Enter Start date',
            type: 'datetime',
            disablePast: true,
            class: 'col-md-3 col-sm-6 col-12',
            name: 'date_added',
            formik: formik,
        },
        {
            label: 'End Date *',
            placeholder: 'Enter End Date',
            disablePast: true,
            type: 'datetime',
            class: 'col-md-3 col-sm-6 col-12',
            name: 'date_closed',
            minDate: dateTimeFormatFunction(formik.values.date_added),
            minDateMessage: `Date should not be before minimal date ${dateTimeFormatFunction(
                formik.values.date_added
            )}`,

            formik: formik,
        },
        {
            label: 'Quantity *',
            type: 'number',
            placeholder: 'Enter Quantity',
            class: 'col-md-3 col-sm-6 col-12',
            name: 'qty',
            formik: formik,
        },
        {
            type: 'misc',
            content: 'Description *',
            class: 'col-12',
        },
        {
            label: 'Description *',
            placeholder: 'Enter Description',
            type: 'ckeditor',
            class: 'col-12 mb-4',
            name: 'desc_proc',
            formik: formik,
        },
        {
            label: 'Enable Auction',
            type: 'checkbox',
            class: 'col-6',
            name: 'auction',
            formik: formik,
        },
        {
            label: 'Auction start price',
            placeholder: 'Enter starting price',
            type: 'number',
            class: 'col-md-3 col-sm-6 col-12',
            name: 'sprice',
            disabled: formik.values.auction ? false : true,
            formik: formik,
        },
        {
            label: 'Auction reserve price',
            placeholder: 'Enter reserve price',
            type: 'number',
            class: 'col-md-3 col-sm-6 col-12',
            name: 'rprice',
            disabled: formik.values.auction ? false : true,
            formik: formik,
        },
        {
            label: 'Enable Buy Now',
            type: 'checkbox',
            class: 'col-6',
            name: 'buynow',
            formik: formik,
        },
        {
            label: 'Buy Now price',
            placeholder: 'Enter buy now price',
            type: 'number',
            class: 'col-md-3 col-sm-6 col-12',
            name: 'bprice',
            disabled: formik.values.buynow ? false : true,
            formik: formik,
        },
        {
            content: '(Per Quantity)',
            type: 'misc',
        },
        {
            type: 'uploadDropZone',
            formik: formik,
            name: 'uploadimages',
            titleText: 'Upload product images *',
            innerText: 'Recommended dimensions: 500px * 500px',
            class: 'col-12',
            folder: 'product',
            multiple: true,
            accept: 'image/*',
            custom: true,
        },
    ]

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'ADD NEW LISTING'
                    : `EDIT LISTING: ${single_project.record.title} `
            }
            open={
                data.status === 'edit' || data.status === 'new'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                setIsLoading(false)
                toggleFullScreenPopup(false)
            }}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            {data.status === 'edit' && (
                                <div className="listingInfo">
                                    <span className="material-icons">info</span>
                                    <h6>
                                        Created at:
                                        <span>
                                            {dateTimeFormatFunction(
                                                single_project.record.created_at
                                            )}
                                        </span>
                                    </h6>
                                    <span className="liDivider">|</span>
                                    <h6>
                                        Last update at:
                                        <span>
                                            {dateTimeFormatFunction(
                                                single_project.record.updated_at
                                            )}
                                        </span>
                                    </h6>
                                    <span className="liDivider">|</span>

                                    <h6>
                                        Posted by:
                                        <span>
                                            {
                                                single_project.record
                                                    .as_employees_emp_firstname
                                            }{' '}
                                            {
                                                single_project.record
                                                    .as_employees_emp_lastname
                                            }{' '}
                                        </span>
                                    </h6>
                                    <span className="liDivider">|</span>
                                    <h6>
                                        Bid Count:
                                        <span>
                                            {single_project.record.bidscount}
                                        </span>
                                    </h6>
                                </div>
                            )}
                            <div className="row">
                                {Object.values(mapData(productListing))}
                            </div>
                            <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                <SecondaryButton
                                    label="Cancel"
                                    onClick={() => {
                                        ;(setIsLoading(false),
                                            toggleFullScreenPopup(false))
                                    }}
                                />
                                {formik.values.id ? (
                                    <>
                                        {formik.values.market_status ===
                                            'draft' && (
                                            <>
                                                <PrimaryButton
                                                    onClick={() => {
                                                        formSubmit('draft')
                                                    }}
                                                    type="button"
                                                    label="Save as Draft"
                                                />
                                            </>
                                        )}
                                        {formik.values.market_status ===
                                            'open' && (
                                            <>
                                                {single_project?.record
                                                    ?.bidscount === 0 &&
                                                    single_project?.record
                                                        ?.sold <= 0 && (
                                                        <>
                                                            <PrimaryButton
                                                                onClick={() => {
                                                                    formSubmit(
                                                                        'open'
                                                                    )
                                                                }}
                                                                type="button"
                                                                label="Update"
                                                            />
                                                        </>
                                                    )}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <PrimaryButton
                                            onClick={() => {
                                                formSubmit('draft')
                                            }}
                                            type="button"
                                            label="Save as Draft"
                                        />
                                    </>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default SingleListing
